import pcAdver from "mptcfe-pc-adver"
/**
 * @description 使用PC广告组件库，依赖于window上的MptcfeUtils
 * @param {*} data
 * @param {*} el
 * @param {*} spmCode
 */
const GoogleAdSense = function (opt) {
    var data = opt && opt.data
    var el = opt && opt.el
    var spmCode = opt && opt.spmCode
    var resourceId = opt && opt.resourceId
    new pcAdver.AdGenerator({
        data: data,
        location: spmCode,
        resourceId: resourceId,
        success: function (adDom) {
            el?.appendChild(adDom[0])
            typeof opt.success === 'function' && opt.success()
        }
    })
}

export default GoogleAdSense